import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";
import fontThin from "../font/Poppins/Poppins-Light.ttf";
import font from "../font/Poppins/Poppins-Medium.ttf";
import image from "../images/mississippi/mississippi-pattern.png";

export const missouriStyleMultiScreen = css`
    html {
        scrollbar-width: none;
        overflow-x: hidden;
    }
    body {
        -ms-overflow-style: none;
        overflow-x: hidden;
    }
    body::-webkit-scrollbar,
    body::-webkit-scrollbar-button {
        display: none;
    }
    @font-face {
        font-family: "poppins";
        src: url("${font}");
        font-weight: bold 1;
        font-style: normal;
    }

    @font-face {
        font-family: "poppins-thin";
        src: url("${fontThin}");
        font-weight: normal 1;
        font-style: normal;
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
        margin-bottom: 1vw;
    }

    .bannerBack {
        width: 22%;
        margin-top: 1.4vw;
        position: absolute;
        margin-left: 54.5%;
    }

    .bannerFront {
        width: 26%;
        margin-left: 20%;
        margin-top: 1.4vw;
        position: absolute;
    }

    .bannerLogo {
        width: 6vw;
        position: relative;
        margin-top: 0.3vw;
        margin-bottom: 1.5vw;
        margin-left: 124.2%;
        z-index: 1000;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.15;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.3;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
    }

    @keyframes opacity {
        0% {
            opacity: 0.05;
        }
        50% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.05;
        }
    }

    .menukaart {
        width: 100vw;
        height: 177.78vw; /* 16:9 ratio */
        display: grid;
        grid-template-columns: auto auto auto;
        position: relative;
    }

    .menu {
        max-width: 96vw;
        height: 46.5vw;
        margin-left: 1vw;
        margin-right: 1vw;
        margin-top: 2vw;
        position: relative;
    }

    .backgroundShadow {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 15px;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
        max-height: 1vh;
    }

    .row {
        display: flex;
        padding-block: 0.9vw;
        padding-left: 0.5vw;
        background-color: rgba(50, 50, 50, 0.1);
    }

    .row:nth-child(even) {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }

    .rowContent {
        padding: 0.22vw 0;
        display: flex;
    }

    .productkind {
        color: white;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .pagebackground {
        background-color: ${COLORS.pricelistBackgroundColor};
        background-repeat: no-repeat;
        background-size: cover;
        width: 100vw;
    }

    .pattern {
        background-image: url("${image}");
        background-size: 100% 70%;
        position: absolute;
        margin-left: -3%;
        top: -8%;
        height: 300vw;
        margin-top: -39%;
        width: 20%;
        opacity: 0.1;
        animation: opacity 10s 1s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
    }

    .redbg {
        position: absolute;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .categoryImage {
        display: block;
        min-height: 7.7vw;
        max-height: 7.7vw;
        width: auto;
        object-fit: contain;
        margin-top: 2vw;
        margin-bottom: 0.75vw;
        margin-left: 1.4vw;
        filter: drop-shadow(0.1vw 0 white) drop-shadow(-0.1vw 0.1vw white);
    }

    .logo {
        position: absolute;
        margin-left: 11.2%;
        margin-top: 40%;
        width: 80%;
        opacity: 0.2;
        animation: rotation 25s 20s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
    }

    .marginTopTitle {
        margin-top: -4vw;
    }

    .title,
    .titleNotAtTop {
        margin-left: 1.8vw;
        font-size: 4.5vw;
        font-weight: 600;
        margin-top: 3vw;
        margin-bottom: -0.5vw;
        position: relative;
        width: 50vw;
        color: white;
        font-family: "poppins", "sans-serif";
        text-shadow: 2px 2px #000000;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        scale: 1.4;
        margin: auto;
        padding: 0 1.5vw; //Padding between badge and namePrice
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
        margin-top: 0.1vw;
        scale: 2;
        transform: translateY(-0.3vw) translateX(0.3vw);
    }

    .nameprice {
        font-size: 2.8vw;
        text-transform: uppercase;
        color: white;
        font-weight: 600;
        font-family: "poppins", "sans-serif";
        margin-top: 0vw; // Fix for font being a little bit up
    }

    .description {
        font-size: 1.4vw;
        color: ${COLORS.descriptionColor};
        //display: none;
    }

    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }

    .priceContainer {
        position: relative;
        right: 0.7vw;
        margin-right: 0.2vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
    }

    .price {
        font-size: 2.8vw;
        width: 9vw;
        //font-weight: bold;
        font-family: "poppins", "sans-serif";
        color: white;
        text-align: right;
    }

    //TODO make those reused on all the vertical pricelists ?
    .oldPrice {
        font-size: 2.2vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        color: grey;
        margin-top: -1vw;
        z-index: 1;
        text-decoration: line-through;
    }

    .discountedPrice {
        font-size: 2.8vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        margin-top: -0.9vw;
        color: red;
        font-weight: bold;
        z-index: 1;
    }

    .priceHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-left: -0.55vw;
        font-size: 2.7vw;
        margin-top: -5vw;
        width: 10vw;
        color: white;
        line-height: 0.9;
        margin-bottom: 0.8vw;
    }

    .priceHeader .amount {
        font-size: 2.9vw;
        font-weight: 800;
        font-family: "poppins", "sans-serif";
    }

    .priceHeader .unit {
        font-size: 2.8vw;
        font-family: "poppins-thin", "sans-serif";
        text-transform: uppercase;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
        margin-right: 1vw;
    }

    .priceHeader .amount {
        font-size: 2.8vw;
        font-weight: 800;
    }

    .priceHeader .unit {
        font-size: 2.6vw;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
        margin-right: 1vw;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legend {
        position: absolute;
        z-index: 100;
        transform: translateY(-1.8vw);
    }

    .legendNew {
        display: none;
    }

    .legendContainer {
        position: relative;
        padding: 15px;
        width: 90vw;
        background-color: rgba(175, 175, 175, 0.7);
        border-radius: 15px;
        display: flex;
        justify-content: center;
    }

    .legend {
        position: absolute;
        bottom: -122.5vw;
        right: -3vw;
        width: 59vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                .legendBadge {
                    height: 3vw;
                }
                .legendRow {
                    margin-top: -0vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 1.75vw;
                    .newIcon {
                        margin-right: 0.4vw;
                        scale: 1.3;
                        transform: translateY(-0.3vw) translateX(0.3vw);
                    }
                    .label {
                        padding-left: 0.6vw;
                        font-size: 2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;
